import { gql } from "../__generated__/gql";

gql(`
    fragment CCTFields on CCT {
        id
        cctEditionId
        cctContractId
        cctVersionId
        name
        hoursPerWeek
        hoursPerWeekDefault
        active
        intercomMainArticleId
        intercomHelpArticleId
        cctUrl
        isIjmMandatory
        fees {
            type
            amount
            repetition
            isAvsSalaryExempt
            countUnit
        }
    }
`);

gql(`
    fragment CCTDetailsFieldValuesFields on CCTDetailsFieldValue {
        value
        criteriaListEntryId
        criteriaStructureId
        autoSelected
    }
`);

gql(`
    fragment CCTDetailsFieldFullValueFields on CCTDetailsFieldFullValue {
        readableValues {
            question
            answer
        }
        tempdataCallValues {
            ...CCTDetailsFieldValuesFields
        }
    }
`);

gql(`
    fragment CCTDetailsFieldFields on CCTDetailsField {
        uniqName
        name
        id
        values {
            ...CCTDetailsFieldValuesFields
        }
        type
    }
`);

export const GET_CCT_BY_EDITION_BY = gql(`
    query GetCct($cctEditionId: String!) {
        getCctByEditionId(cctEditionId: $cctEditionId) {
            ...CCTFields
        }
    }
`);

export const FIND_CCT = gql(`
    query FindCct($stateCode: String, $useLse: Boolean, $offset: Int, $limit: Int, $startDate: Date) {
        findCct(stateCode: $stateCode, useLse: $useLse, offset: $offset, limit: $limit, startDate: $startDate) {
            elements {
                ...CCTFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

// field is a recursive model. This query
export const GET_CCT_DETAILS_FIELDS = gql(`
    query GetCctDetailsFields($cctEditionId: String!) {
        getCctDetailsFields(cctEditionId: $cctEditionId) {
            ...CCTDetailsFieldFields
            children {
                ...CCTDetailsFieldFields
                children {
                    ...CCTDetailsFieldFields
                    children {
                        ...CCTDetailsFieldFields
                        children {
                            ...CCTDetailsFieldFields
                        }
                    }
                }
            }
        }
    }
`);

export const GET_CCT_DETAILS_FIELD_VALUES_FROM_PARENT = gql(`
    query GetCctDetailsFieldValues(
        $cctEditionId: String!
        $criteriaStructureId: Int!
        $parentValues: [CCTDetailsFieldValueInput!]!
    ) {
        getCctDetailsFieldValuesFromParent(
            cctEditionId: $cctEditionId
            criteriaStructureId: $criteriaStructureId
            parentValues: $parentValues
        ) {
            ...CCTDetailsFieldValuesFields
        }
    }
`);
